<ngb-alert
  *ngIf="!staticAlertClosed && message"
  [dismissible]="true"
  [type]="messageType"
  (closed)="staticAlertClosed = true"
>
  {{ message | ioxTranslate }}
</ngb-alert>
